import { AnchorProvider, Program } from '@coral-xyz/anchor'
import { NftVoter } from '@helium/modular-governance-idls/lib/types/nft_voter'
import { init } from '@helium/nft-voter-sdk'
import { useConnection } from '@solana/wallet-adapter-react'
import { Connection, PublicKey } from '@solana/web3.js'
import { useAsync } from 'react-async-hook'
import NftVoterIdl from '../../tasks/governance/nft_voter.json'
import * as anchor from '@coral-xyz/anchor'
import { Asset } from '@helium/spl-utils'

const heliusMetadataUrl = process.env.NEXT_PUBLIC_HELIUS_METADATA_URL

export function useVotes(proposal: PublicKey) {
  const { connection: conn } = useConnection()
  const { result: sdk, loading: loadingSdk } = useAsync(
    async (conn: Connection) =>
      init(
        new AnchorProvider(conn, {} as any, {}),
        new PublicKey('nftvLQ5t6xe2nQF1NBmBBmn15ed59tU6vSCkwQNEqdc'),
        NftVoterIdl as any,
      ),
    [conn],
  )
  // @ts-ignore
  const { result: markers, loading } = useAsync(
    async (sdk: any | undefined) => {
      if (sdk) {
        const mks = (
          await sdk.account.voteMarkerV0.all([
            {
              memcmp: {
                offset: 8 + 2 * 32,
                bytes: proposal.toBase58(),
              },
            },
          ])
        ).map((i: any) => i.account)

        const response = await fetch(
          process.env.NEXT_PUBLIC_REACT_APP_SOLANA_RPC_HOST,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              jsonrpc: '2.0',
              id: 'text',
              method: 'getAssetBatch',
              params: {
                ids: mks.map((m: any) => m.mint.toBase58()),
              },
            }),
          },
        )
        const data: Asset[] = (await response.json())?.result

        const images = data.map((m: Asset) => m?.content?.files?.[0]?.uri)

        // Check if aura attribute is true
        const isLegendary = data.map((m: any) =>
          m?.content?.metadata?.attributes?.find(
            (a: any) => a?.trait_type?.toLowerCase() === 'aura',
          ),
        )

        return mks.map((m: any, i: number) => ({
          ...m,
          image: images[i],
          isLegendary: isLegendary[i],
        }))
      }
    },
    [sdk],
  )

  // isLegendary counts as 2 votes
  const calculateTotalVotes = (markers: any[]) => {
    if (!markers) {
      return 0
    }

    return markers?.reduce((acc, curr) => {
      return acc + (curr.isLegendary ? 2 : 1)
    }, 0)
  }

  // Count the number of votes for each choice given that isLegendary counts as 2 votes
  const calculateVotesForChoice = (markers: any[], choice: number) => {
    if (!markers) return 0
    return markers?.reduce((acc, curr) => {
      return (
        acc +
        (curr?.choices?.includes(choice) ? (curr?.isLegendary ? 2 : 1) : 0)
      )
    }, 0)
  }

  return {
    loading: loading || loadingSdk,
    markers,
    calculateTotalVotes,
    calculateVotesForChoice,
  }
}
